import {useEffect} from 'react';

import {addSsoLink} from '@/state/slices/globalSlice';
import {dispatch} from '@/state/store';

type Args = {
    expirationDate?: number;
    formattedSsoTemplate: string | null;
};

const getLinkExpiration = (expirationDate: number) => {
    const expiredInMs = expirationDate - Date.now();

    return {
        expiredInMs,
        isExpired: expiredInMs < 0,
    };
};

/**
 * Clears the cached SSO link from the store as soon as it expires so that the
 * next render of `useSsoLinkFetch` re-prefetches it. Mirrors the legacy
 * `useSsoLinkRefresh` hook.
 */
const useSsoLinkRefresh = ({expirationDate, formattedSsoTemplate}: Args) => {
    useEffect(() => {
        if (!expirationDate || !formattedSsoTemplate) return;

        const {expiredInMs, isExpired} = getLinkExpiration(expirationDate);
        const timeoutMs = isExpired ? 0 : expiredInMs;

        const timeout = setTimeout(() => {
            // Clear stored ssoLink data so it will be fetched again.
            dispatch(addSsoLink({template: formattedSsoTemplate}));
        }, timeoutMs);

        return () => clearTimeout(timeout);
    }, [expirationDate, formattedSsoTemplate]);
};

export default useSsoLinkRefresh;
